/*
 * Venn Platform API 1.0.0 Operations for "advisory"
 * Automatically generated file - do not modify!
 */

import type { AdvisoryFeeConfig } from '../types';
import type { OperationResult } from '../../utils';
import { buildRequestInit, extractError, retryGeneratedFetch } from '../../utils';

/** No summary or description available. Please update the summary or description field in the Openapi spec. */
export async function getAdvisoryFeeConfig(signal?: AbortSignal): Promise<OperationResult<AdvisoryFeeConfig>> {
  const endpoint = '/api/advisory-fee-config';
  const requestInit = buildRequestInit({ method: 'GET', signal });
  const response = await retryGeneratedFetch('GET', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: AdvisoryFeeConfig = (await response.json()) as AdvisoryFeeConfig;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** No summary or description available. Please update the summary or description field in the Openapi spec. */
export async function saveAdvisoryFeeConfig(
  body?: Partial<AdvisoryFeeConfig>,
  signal?: AbortSignal,
): Promise<OperationResult<AdvisoryFeeConfig>> {
  const endpoint = '/api/advisory-fee-config';
  const requestInit = buildRequestInit({
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await retryGeneratedFetch('PUT', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: AdvisoryFeeConfig = (await response.json()) as AdvisoryFeeConfig;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
